import React, { useEffect, useRef } from 'react';
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { DateTimePicker } from "@mui/x-date-pickers/DateTimePicker";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";

interface AdvTimeInputProps {
  onAdvTimeChange: (time: Date | null, isValid: boolean) => void;
}

const AdvTimeInput: React.FC<AdvTimeInputProps> = ({ onAdvTimeChange }) => {
  const [advTime, setAdvTime] = React.useState<Date | null>(null);
  const [showErrorAdv, setShowErrorAdv] = React.useState("");
  const [isAdvValid, setIsAdvValid] = React.useState(false); 
  const advtimeRef = useRef(advTime);

  useEffect(() => {
    advtimeRef.current = advTime;
  }, [advTime]);

  useEffect(() => {
    // Check if advTime/etrTime is in the future
    const checkAdvEtr = () => {
      const currentDateTime = new Date();

      if (advtimeRef.current && advtimeRef.current < currentDateTime) {
        setShowErrorAdv("ADV can not be in the past");
        setIsAdvValid(false);
        onAdvTimeChange(advtimeRef.current, false);
      }
    };

    // Calculate time until next minute
    const now = new Date();
    const delay = 60 - now.getSeconds();

    // run check on the exact minute change
    const timeout = setTimeout(() => {
      checkAdvEtr();

      // Then update advTime every minute
      const interval = setInterval(() => {
        checkAdvEtr();
      }, 60000); // run each minute
      return () => {
        clearInterval(interval);
      };
    }, delay * 1000);
    return () => {
      clearTimeout(timeout);
    };
  }, [onAdvTimeChange]);
    
  const handleAdvTimeChange = (adv: Date) => {
    setShowErrorAdv("");
    setIsAdvValid(true);
    setAdvTime(adv);
    const currentDateTime = new Date();
    // Check if advTime is in the future
    if (adv && adv < currentDateTime) {
      setShowErrorAdv("ADV can not be in the past");
      setIsAdvValid(false);
    }
    onAdvTimeChange(adv, adv !== null && adv >= currentDateTime);
  };

  const handleInvalidDate = (error: any) => {
    if (error !== null) {
      if(error === "disablePast"){
        setShowErrorAdv("ADV can not be in the past");
      } else {
        setShowErrorAdv("Enter a valid ADV");
      }
      setIsAdvValid(false);
      onAdvTimeChange(null, false);
    } else {
      setIsAdvValid(true);
    }
  };

  return (
    <LocalizationProvider dateAdapter={AdapterDateFns}>
      <DateTimePicker
        data-testid="adv-date-time-picker"
        label="ADV"
        ampm={false}
        format="HH:mm MM/dd/yyyy"
        timeSteps={{ minutes: 15 }}
        value={advTime}
        onChange={handleAdvTimeChange}
        onError={handleInvalidDate}
        disablePast={true}
      />
      {!isAdvValid && <div className="dateTimeError">{showErrorAdv}</div>}
    </LocalizationProvider>
  );
};

export default AdvTimeInput;